import { render, staticRenderFns } from "./DocenteLista.vue?vue&type=template&id=6b80d224&"
import script from "./DocenteLista.vue?vue&type=script&lang=js&"
export * from "./DocenteLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports